module.exports = __webpack_public_path__ + "img/builders-group-logo.253cdcba.jpg";